import { createPortal } from 'preact/compat';
import { Dropdown } from 'components/dropdown/Dropdown.tsx';
import { localize } from 'i18n/localize.ts';
import { CommonContainer } from './CommonContainer';
import { useIsDesktopAndLarger } from 'signals/mediaQuery';
import { DeviceTypes } from 'utils/constants';

const $t = localize();

/**
 * Same as {@link CommonContainer} but renders the dropdown in a portal if the screen width is less than 900px.
 * Look at tailwind config for the breakpoint on change.
 * Useful to bypass issues caused by overflow:hidden, transform, @container, ... of the parent container.
 * @param mobileTitle
 * @param isOpen
 * @param children
 * @param toggleOpen
 * @param dropdownRef
 * @param dataTest
 * @param placement
 * @param className
 * @param aria
 * @param id
 * @param value
 * @constructor
 */
export const CommonPortalContainer = ({
	mobileTitle = $t.offerMoreActions.title,
	isOpen,
	children,
	toggleOpen,
	dropdownRef,
	dataTest,
	placement,
	className,
	aria,
	id,
	value,
}: Dropdown.RenderContainerProps) => {
	const isLessThanDesktop = !useIsDesktopAndLarger(DeviceTypes.desktop.breakpoint, true).value;

	const elementJsx = (
		<CommonContainer
			isOpen={isOpen}
			toggleOpen={toggleOpen}
			dropdownRef={dropdownRef}
			placement={placement}
			dataTest={dataTest}
			id={id}
			className={className}
			aria={aria}
			mobileTitle={mobileTitle}
			value={value}
		>
			{children}
		</CommonContainer>
	);

	return isLessThanDesktop ? createPortal(elementJsx, globalThis.document.body) : elementJsx;
};
